import React, { Component } from 'react';
import ReactTypingEffect from 'react-typing-effect';
import profilepic from '../img/foto_gelar.jpg';
import Social from '../components/Social'


class Home extends Component {
    render(){
        return(
            <div className="condiv home">
                <img src={profilepic} className="profilepic" alt=''></img>
                <ReactTypingEffect className="typingeffect" text={['Hi there!',"I'm Gelar Pambudi Adhiluhung"]} speed={75} eraseDelay={650}/>
                <br></br>
                <h3>I'm Gelar, Telecommunication Engineering fresh graduate.</h3>
                <h3>I have interest in cloud computing, IT infrastructure, and web technology</h3>
                <Social/>
            </div>

        )
    }
}

export default Home